
export const ENDPOINT_MESSAGE_RECEIVED = 'ENDPOINT_MESSAGE_RECEIVED';

export const STT_TOGGLE_MESSAGE = 'STT_TOGGLE_MESSAGE';

export const STT_CHANGE_TARGET_LANGUAGE = 'STT_CHANGE_TARGET_LANGUAGE';

export const STT_TRANSLATION_TOGGLE_MESSAGE = 'STT_TRANSLATION_TOGGLE_MESSAGE';

export const STT_CHANGE_TARGET_TRANS_LANGUAGE = 'STT_CHANGE_TARGET_TRANS_LANGUAGE';

export const STT_WS_SERVER_MESSAGE = 'STT_WS_SERVER_MESSAGE';

export const STT_RETRY_REQUEST = 'STT_RETRY_REQUEST';

export const STT_RETRY_CHECK = 'STT_RETRY_CHECK';

export const STT_RECORDER_MESSAGE = 'STT_RECORDER_MESSAGE';

export const UPDATE_STT_MESSAGE = 'UPDATE_STT_MESSAGE';

export const REMOVE_STT_MESSAGE = 'REMOVE_STT_MESSAGE';

export const UPDATE_TRANS_MESSAGE = 'UPDATE_TRANS_MESSAGE';

export const REMOVE_TRANS_MESSAGE = 'REMOVE_TRANS_MESSAGE';

export const CHANGE_SUBTITLE_FONT_SIZE = 'CHANGE_SUBTITLE_FONT_SIZE';

export const CHANGE_SUBTITLE_VISIBILITY = 'CHANGE_SUBTITLE_VISIBILITY';

export const ADD_STT_HISTORY = 'ADD_STT_HISTORY';